var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Visibility, Preview } from "@mui/icons-material";
import { IconButton } from "@sequentech/ui-essentials";
import { Box, Typography, Button } from "@mui/material";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { EPublishActions } from "@/types/publishActions";
import { List, TextField, TextInput, BooleanInput, BooleanField, DatagridConfigurable, WrapperField, } from "react-admin";
import { PublishActions } from "./PublishActions";
import { EPublishActionsType, EPublishType } from "./EPublishType";
import { HeaderTitle } from "@/components/HeaderTitle";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { ActionsColumn } from "@/components/ActionButons";
import { ResetFilters } from "@/components/ResetFilters";
import { AuthContext } from "@/providers/AuthContextProvider";
import { usePublishPermissions } from "./usePublishPermissions";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
var OMIT_FIELDS = [];
var filters = [
    _jsx(TextInput, { source: "id" }, 0),
    _jsx(BooleanInput, { source: "is_generated" }, 1),
];
export var PublishList = function (_a) {
    var status = _a.status, publishType = _a.publishType, electionStatus = _a.electionStatus, electionPresentation = _a.electionPresentation, electionId = _a.electionId, electionEventId = _a.electionEventId, kioskModeEnabled = _a.kioskModeEnabled, onlineModeEnabled = _a.onlineModeEnabled, earlyVotingEnabled = _a.earlyVotingEnabled, telephoneVotingEnabled = _a.telephoneVotingEnabled, changingStatus = _a.changingStatus, _b = _a.onGenerate, onGenerate = _b === void 0 ? function () { return null; } : _b, _c = _a.onChangeStatus, onChangeStatus = _c === void 0 ? function () { return null; } : _c, _d = _a.setBallotPublicationId, setBallotPublicationId = _d === void 0 ? function () { return null; } : _d, _e = _a.onPreview, onPreview = _e === void 0 ? function () { return null; } : _e;
    var t = useTranslation().t;
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var _f = usePublishPermissions(), canReadPublish = _f.canReadPublish, canPublishCreate = _f.canPublishCreate, showPublishPreview = _f.showPublishPreview, showPublishView = _f.showPublishView;
    /**
     * Specific Handler for "Publish Changes" Button: Incorporates
     * re-authentication logic for actions that require Gold-level permissions.
     */
    var handlePublish = function () { return __awaiter(void 0, void 0, void 0, function () {
        var baseUrl, electionEventPublishTabIndex, electionPublishTabIndex, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!!isGoldUser()) return [3 /*break*/, 2];
                    baseUrl = new URL(window.location.href);
                    if (publishType === EPublishType.Event) {
                        electionEventPublishTabIndex = localStorage.getItem("electionEventPublishTabIndex");
                        baseUrl.searchParams.set("tabIndex", electionEventPublishTabIndex !== null && electionEventPublishTabIndex !== void 0 ? electionEventPublishTabIndex : "8");
                    }
                    else {
                        electionPublishTabIndex = localStorage.getItem("electionPublishTabIndex");
                        baseUrl.searchParams.set("tabIndex", electionPublishTabIndex !== null && electionPublishTabIndex !== void 0 ? electionPublishTabIndex : "4");
                    }
                    sessionStorage.setItem(EPublishActions.PENDING_PUBLISH_ACTION, "true");
                    return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    onGenerate();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Re-authentication failed:", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("publish.empty.header") }), canPublishCreate && canReadPublish && (_jsxs(_Fragment, { children: [_jsxs(Button, { onClick: handlePublish, className: "publish-add-button", children: [_jsx(IconButton, { icon: faPlus, fontSize: "24px" }), t("publish.empty.action")] }), _jsx(Typography, { variant: "body1", paragraph: true, children: t("common.resources.noResult.askCreate") })] }))] })); };
    var actions = [
        {
            icon: _jsx(Visibility, { className: "publish-visibility-icon" }),
            action: setBallotPublicationId,
            showAction: function () { return showPublishView; },
        },
        {
            icon: _jsx(Preview, { className: "publish-preview-icon" }),
            action: onPreview,
            showAction: function () { return showPublishPreview; },
        },
    ];
    if (!canReadPublish) {
        return _jsx(Empty, {});
    }
    return (_jsx(Box, { children: _jsxs(List, { actions: _jsx(PublishActions, { publishType: publishType, status: status, electionStatus: electionStatus, electionPresentation: electionPresentation, changingStatus: changingStatus, kioskModeEnabled: kioskModeEnabled, onlineModeEnabled: onlineModeEnabled, earlyVotingEnabled: earlyVotingEnabled, telephoneVotingEnabled: telephoneVotingEnabled, onGenerate: onGenerate, onChangeStatus: onChangeStatus, type: EPublishActionsType.List }), resource: "sequent_backend_ballot_publication", filter: electionId
                ? {
                    election_event_id: electionEventId,
                    election_id: electionId,
                }
                : {
                    election_event_id: electionEventId,
                }, sort: { field: "created_at", order: "DESC" }, filters: filters, sx: { flexGrow: 2 }, empty: _jsx(Empty, {}), disableSyncWithLocation: true, children: [_jsx(ResetFilters, {}), _jsx(HeaderTitle, { title: "publish.header.history", subtitle: "" }), _jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, omit: OMIT_FIELDS, bulkActionButtons: false, children: [_jsx(TextField, { source: "id" }), _jsx(BooleanField, { source: "is_generated" }), _jsx(TextField, { source: "published_at" }), _jsx(TextField, { source: "created_at" }), _jsx(WrapperField, { label: String(t("common.label.actions")), children: _jsx(ActionsColumn, { actions: actions }) })] })] }) }));
};
